import React from "react";

const Container = (props) => {
    const { className, ...otherProps } = props;
    const css = `px-4 min-w-app max-w-app mx-auto ${
        props.className ?? ""
    }`.trim();
    return (
        <div className={css} {...otherProps}>
            {props.children}
        </div>
    );
};

export default Container;
